import { makeStyles } from '@material-ui/core/styles';

const useDropdownStyle = makeStyles((theme) => ({
	root: {
		borderBottom: '1px solid var(--text-low-emphasis) !important',
		minHeight: '50px !important',
		minWidth: '316px !important',
		'&:last-child': {
			borderBottom: 'none !important',
		},
		fontSize: 'var(--text-size-subtitle) !important',
		color: 'var(--text-high-emphasis) !important',
	},
	menuItemSelected: {
		backgroundColor: 'var(--primary-label) !important',
	},
}));

export { useDropdownStyle };
